import Validator from "js-object-validation";
import { message } from "../common";

export const forget = (data) => {
  const validations = {
    email: {
      required: true,
      email: true,
    },
  };
  // Error messages
  const messages = {
    email: {
      required: message.Required.replace(":item", "email"),
      email: message.InvalidEmail,
    },
  };

  const { isValid, errors } = Validator(data, validations, messages);
  return {
    isValid,
    errors,
  };
};
